import axios from "axios";

// export const caxios = axios.create({
//   baseURL: `http://10.5.5.12`
// });
export const caxios = axios.create({
    baseURL: `https://tnt-65859504419.asia-northeast3.run.app/`
});


caxios.interceptors.request.use((config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
});
